import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setError } from '../modules/App/ErrorsActions';

import { ERRORS, trackErrorViewed } from '../util/mixpanel';

export default function (ComposedComponent) {
  class SubscriptionValidation extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    constructor(props) {
      super(props);
      this.state = {
        block: false,
      };
    }

    componentDidMount() {
      this.check();
    }

    redirect() {
      if (this.props.outside) {
        this.props.router.replace(`/limitreached${ this.props.router.location.search || '' }`);
      } else {
        trackErrorViewed(ERRORS.BOARD_LIMIT_REACHED);
        
        this.props.dispatch(
          setError("You're all out of dashboards! Please upgrade your plan to add a new one.", { log: false })
        );
        this.props.router.goBack();
      }
    }

    check() {
      if (
        this.props.user.allowedDashboards > 0 &&
        this.props.dashboards > 0 &&
        this.props.dashboards >= this.props.user.allowedDashboards
      ) {
        this.redirect();
        this.setState({ block: true });
      }
    }

    render() {
      return !this.state.block ? <ComposedComponent {...this.props} /> : null;
    }
  }

  function mapStateToProps(state) {
    const dashboards = state.dashboards.loaded ? state.dashboards.list.length : state.auth.user.dashboards;

    return {
      outside: state.app.outside,
      user: state.auth.user,
      dashboards,
    };
  }

  return withRouter(connect(mapStateToProps)(SubscriptionValidation));
}
